<div class="wrapper shrink-rule" [style.background-color]="backgroundColor">
    <div class="front">
        <img [src]="iconUrl" alt="Icon">
    </div>
    <div class="back">
        {{rank}}
    </div>
</div>